module.exports = __webpack_public_path__ + "static/media/image_57.b3150fa7.png";